import { useEffect, useRef } from 'react';
import Link from 'src/components/primitives/Link/Link';
import { UserSurveyContentProps } from 'src/components/UserSurvey/types';
import { DRIFT_DISCORD_URL } from 'src/constants/constants';
import useSyncedRef from 'src/hooks/utils/useSyncedRef';
import { SetTimeoutResult } from 'src/utils/UtilityTypes';

export default function UserSurveyThankYouPage({
	survey,
	closeSurvey,
}: Pick<UserSurveyContentProps, 'survey' | 'closeSurvey'>) {
	// Auto-close the survey after a bit since we're done with it.
	useAutoCloseSurvey(closeSurvey);

	// Extra message that can be shown as the first sentence.
	const message = survey.appearance?.thankYouMessageDescription;

	return (
		<span className="typo-body-xs text-text-default">
			{message ? `${message} ` : ''}We&apos;d love to get in touch to provide
			direct support. You can always contact us on{' '}
			<Link href="tg://resolve?domain=Ox181z" rightIcon="none">
				Telegram
			</Link>{' '}
			or{' '}
			<Link href={DRIFT_DISCORD_URL} rightIcon="none" openInNewTab>
				Discord
			</Link>
			.
		</span>
	);
}

function useAutoCloseSurvey(
	closeSurvey: UserSurveyContentProps['closeSurvey']
) {
	const autoCloseTimerRef = useRef<SetTimeoutResult>(null);
	const closeSurveyRef = useSyncedRef(closeSurvey);

	useEffect(() => {
		autoCloseTimerRef.current = setTimeout(() => {
			closeSurveyRef.current();
		}, 20_000);

		return () => {
			if (autoCloseTimerRef.current) {
				clearTimeout(autoCloseTimerRef.current);
				autoCloseTimerRef.current = null;
			}
		};
	}, []);
}
